import { HttpResponse } from '@tda/utilities';
import { ChatClient } from './chat-http-client';

export async function deleteConversation(assistantCode: string, sessionId: string): Promise<HttpResponse<string>> {
  return await ChatClient.delete<string>(`/assistants/${assistantCode}/sessions/${sessionId}`);
}
